import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CatalogStore from './store/CatalogStore';
import UserStore from './store/UserStore';
import AppStore from './store/AppStore';
import ProductCategoriesStore from './store/ProductCategoriesStore';

export const Context = createContext(null)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value={{
        user: new UserStore(),
        catalog: new CatalogStore(),
        app: new AppStore(),
        productCategories: new ProductCategoriesStore(),
    }}>
        <App />
    </Context.Provider>
);
